import { ChainPath } from '@ankr.com/chains-list';
import { IUsageTopElement } from 'multirpc-sdk';

import { mapSharkChainToChainPath } from 'modules/chains/utils/mapSharkChainNameToChainPath';

export interface ISumBlockchainsCountsByChainPaths {
  blockchainsCounts: IUsageTopElement[];
  chainPaths: ChainPath[];
}

export const sumBlockchainsCountsByChainPaths = ({
  blockchainsCounts,
  chainPaths,
}: ISumBlockchainsCountsByChainPaths) =>
  chainPaths.reduce((sum, id) => {
    const currentChainStats = blockchainsCounts.find(
      ({ name }) => mapSharkChainToChainPath(name) === id,
    );

    return sum + (Number(currentChainStats?.count) || 0);
  }, 0);
